module.exports = __webpack_public_path__ + "184f5e5825771eb5bd57271b3218e6c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/V@2x.png
// module id = 847
// module chunks = 0